"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteFlightAndFlightPassengerList = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const actionLayout_1 = require("../../../Table/columns/actionsColumn/actionLayout");
const views = {
    deleteFlight: {
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Action:deleteTitle', defaultMessage: 'Delete flight' })),
        iconName: 'x',
        targetOption: 'deleteFlight',
    },
    passengerList: {
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Action:passengerList', defaultMessage: 'Passenger list' })),
        iconName: 'users-circle',
        targetOption: 'passengerList',
    },
};
exports.deleteFlightAndFlightPassengerList = (0, actionLayout_1.createActionLayout)([
    (state) => state === 'deleteFlight' ? views.deleteFlight : views.passengerList,
]);
//# sourceMappingURL=deleteFlightAndFlightPassengerList.js.map